import React from "react";

export default function TableRow({ item }) {
  return (
    <div className="row-main">
      <strong>{item[0]}</strong>
      <strong>{item[1]}</strong>
    </div>
  );
}
